import { render, staticRenderFns } from "./Listado.vue?vue&type=template&id=099c20ac&scoped=true"
import script from "./Listado.vue?vue&type=script&lang=js"
export * from "./Listado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099c20ac",
  null
  
)

export default component.exports